// local
// libs
var FEATURES = require('./features');
// models
var Client = require('../consts/client');
var Account = require('../consts/account');
var permissions = {};

// MONITOR
permissions[FEATURES.OXIGEN_BY_PATIENT] = {};
permissions[FEATURES.OXIGEN_BY_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.OXIGEN_BY_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_RESTITUTION] = {};
permissions[FEATURES.UPDATE_RESTITUTION][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_RESTITUTION][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_PRESCRIPTION] = {};
permissions[FEATURES.UPDATE_PRESCRIPTION][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_PRESCRIPTION][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];

// DELIVERY
permissions[FEATURES.LIST_PENDING_DELIVERY] = {};
permissions[FEATURES.LIST_PENDING_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.LIST_PENDING_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.SAVE_PENDING_DELIVERY] = {};
permissions[FEATURES.SAVE_PENDING_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.SAVE_PENDING_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_CONFIRM_DELIVERY] = {};
permissions[FEATURES.LIST_CONFIRM_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.LIST_CONFIRM_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CONFIRM_PENDING_DELIVERY] = {};
permissions[FEATURES.CONFIRM_PENDING_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CONFIRM_PENDING_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_EDIT_CONFIRM_DELIVERY] = {};
permissions[FEATURES.LIST_EDIT_CONFIRM_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.LIST_EDIT_CONFIRM_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.SAVE_EDIT_CONFIRM_DELIVERY] = {};
permissions[FEATURES.SAVE_EDIT_CONFIRM_DELIVERY][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.SAVE_EDIT_CONFIRM_DELIVERY][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];

// Client
permissions[FEATURES.LIST_CLIENT] = {};
permissions[FEATURES.LIST_CLIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_CLIENT] = {};
permissions[FEATURES.VIEW_CLIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_CLIENT] = {};
permissions[FEATURES.CREATE_CLIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_CLIENT] = {};
permissions[FEATURES.UPDATE_CLIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.REMOVE_CLIENT] = {};
permissions[FEATURES.REMOVE_CLIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];

// Account
permissions[FEATURES.LIST_ACCOUNT] = {};
permissions[FEATURES.LIST_ACCOUNT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_ACCOUNT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN];
permissions[FEATURES.LIST_ACCOUNT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN];
permissions[FEATURES.VIEW_ACCOUNT] = {};
permissions[FEATURES.VIEW_ACCOUNT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_ACCOUNT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN];
permissions[FEATURES.VIEW_ACCOUNT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CREATE_ACCOUNT] = {};
permissions[FEATURES.CREATE_ACCOUNT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CREATE_ACCOUNT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CREATE_ACCOUNT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_ACCOUNT] = {};
permissions[FEATURES.UPDATE_ACCOUNT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_ACCOUNT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_ACCOUNT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN];
permissions[FEATURES.REMOVE_ACCOUNT] = {};
permissions[FEATURES.REMOVE_ACCOUNT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.REMOVE_ACCOUNT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN];
permissions[FEATURES.REMOVE_ACCOUNT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN];

// Patient
permissions[FEATURES.LIST_PATIENT] = {};
permissions[FEATURES.LIST_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_PATIENT] = {};
permissions[FEATURES.VIEW_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_PATIENT] = {};
permissions[FEATURES.CREATE_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CREATE_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_PATIENT] = {};
permissions[FEATURES.UPDATE_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.REMOVE_PATIENT] = {};
permissions[FEATURES.REMOVE_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.INITIALIZE_PATIENT] = {};
permissions[FEATURES.INITIALIZE_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.INITIALIZE_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.INITIALIZE_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.DEACTIVATE_PATIENT] = {};
permissions[FEATURES.DEACTIVATE_PATIENT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.DEACTIVATE_PATIENT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.DEACTIVATE_PATIENT][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];

// Device
permissions[FEATURES.LIST_DEVICE] = {};
permissions[FEATURES.LIST_DEVICE][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_DEVICE][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_DEVICE][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_DEVICE] = {};
permissions[FEATURES.VIEW_DEVICE][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_DEVICE][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_DEVICE][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_DEVICE] = {};
permissions[FEATURES.CREATE_DEVICE][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_DEVICE] = {};
permissions[FEATURES.UPDATE_DEVICE][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_DEVICE][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.REMOVE_DEVICE] = {};
permissions[FEATURES.REMOVE_DEVICE][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];

// Supplier
permissions[FEATURES.LIST_SUPPLIER] = {};
permissions[FEATURES.LIST_SUPPLIER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_SUPPLIER][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.LIST_SUPPLIER][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_SUPPLIER] = {};
permissions[FEATURES.VIEW_SUPPLIER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_SUPPLIER][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.VIEW_SUPPLIER][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_SUPPLIER] = {};
permissions[FEATURES.CREATE_SUPPLIER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.CREATE_SUPPLIER][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.CREATE_SUPPLIER][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_SUPPLIER] = {};
permissions[FEATURES.UPDATE_SUPPLIER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.UPDATE_SUPPLIER][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.UPDATE_SUPPLIER][Client.TYPE.HOSPITAL] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];
permissions[FEATURES.REMOVE_SUPPLIER] = {};
permissions[FEATURES.REMOVE_SUPPLIER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];

// Cylinder
permissions[FEATURES.LIST_CYLINDER] = {};
permissions[FEATURES.LIST_CYLINDER][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN];
permissions[FEATURES.LIST_CYLINDER][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN, Account.PROFILE.DEFAULT];

// Report
permissions[FEATURES.OXIGEN_USAGE_REPORT] = {};
permissions[FEATURES.OXIGEN_USAGE_REPORT][Client.TYPE.SALVUS] = [Account.PROFILE.ADMIN /*, Account.PROFILE.DEFAULT*/];
permissions[FEATURES.OXIGEN_USAGE_REPORT][Client.TYPE.HOMECARE] = [Account.PROFILE.ADMIN /*, Account.PROFILE.DEFAULT*/];

module.exports = permissions;